import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AdministratorEntity } from '@domain/AdministratorEntity';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class GestionService {
  private readonly http = inject(HttpClient);

  sendRequest(entity: AdministratorEntity): Observable<unknown> {
    return this.http.post(`${environment.apiGestion}/${entity.type}`, entity);
  }
}
